import { sanitizeHtml } from '@/utils/helpers/html';
// import { useMemo } from 'react';

interface ArticleContentProps {
    content: string;
    className?: string;
}

/**
 * Transforms HTML content to add caption displays below images that have data-caption attributes.
 * This is used to render Tiptap editor content that includes image captions.
 */
// function transformContentWithCaptions(html: string): string {
//     if (!html) return '';

//     // Find all img tags with data-caption attribute and wrap them with a figure + figcaption
//     const imgWithCaptionRegex = /<img([^>]*?)data-caption="([^"]+)"([^>]*?)>/gi;

//     return html.replace(imgWithCaptionRegex, (_match, before, caption, after) => {
//         // Extract any existing style
//         const styleMatch = (before + after).match(/style="([^"]*)"/);
//         const existingStyle = styleMatch ? styleMatch[1] : '';

//         // Remove style from before/after to avoid duplication
//         const cleanBefore = before.replace(/style="[^"]*"/g, '');
//         const cleanAfter = after.replace(/style="[^"]*"/g, '');

//         return `<figure class="image-with-caption my-4">
//       <img${cleanBefore}data-caption="${caption}"${cleanAfter} style="${existingStyle}" class="rounded-lg max-w-full h-auto" />
//       <figcaption class="text-sm text-gray-500 mt-2 italic">${caption}</figcaption>
//     </figure>`;
//     });
// }

/**
 * ArticleContent component renders HTML content with proper caption handling for images.
 * Use this instead of raw dangerouslySetInnerHTML when displaying Tiptap editor content.
 */
export function ArticleContent({ content, className = '' }: ArticleContentProps) {
    const transformedContent = sanitizeHtml(content);

    return (
        <div
            className={`prose prose-lg max-w-none ${className}`}
            dangerouslySetInnerHTML={{ __html: transformedContent }}
        />
    );
}

export default ArticleContent;
